import HttpFactory from '../factory'
import { OwnerType } from '../types/contact-point'
import type { RelationshipInterface, Relationship, Person } from '../types/patient/relationship'

class RelationshipsModule extends HttpFactory<any[]> {
  private PATH = 'relationships'

  async get(id: string): Promise<RelationshipInterface[]> {
    return await this.call<any>('GET', `/persons/${id}/${this.PATH}`)
  }

  async getPersonRelation(id: string): Promise<RelationshipInterface[]> {
    const result = await this.call<any>('GET', `/${this.PATH}?ownerType=${OwnerType.person}&ownerId=${id}`)
    return result?.items || []
  }

  async getPractitionerRelation(id: string): Promise<RelationshipInterface[]> {
    const result = await this.call<any>('GET', `/${this.PATH}?ownerType=${OwnerType.practitioner}&ownerId=${id}`)
    return result?.items || []
  }

  async getOrganizationRelation(id: string): Promise<RelationshipInterface[]> {
    const result = await this.call<any>('GET', `/${this.PATH}?ownerType=${OwnerType.organization}&ownerId=${id}`)
    return result?.items || []
  }

  async getPersonRelationById(id: string): Promise<RelationshipInterface> {
    const result = await this.call<any>('GET', `/${this.PATH}/${id}`)
    return result
  }

  async save(data: Relationship): Promise<Relationship> {
    if (data.id) {
      let patchData: any = {}
      if (data.type) {
        patchData.type = data.type
      }
      if (data.roles) {
        patchData.roles = data.roles
      }
      return this.call<any>('PATCH', `${this.PATH}/${data.id}?revision=${data.revision}`, patchData)
    } else {
      return await this.call<any>('POST', `/${this.PATH}`, data)
    }
  }

  async delete(id: string, revision: string): Promise<Relationship> {
    return await this.call<any>('DELETE', `/${this.PATH}/${id}?revision=${revision}`)
  }
}

export default RelationshipsModule
